export default __webpack_public_path__ + "static/media/Laurielle.efbc9fb3.png";